import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../../utils/context/Auth/AuthContext.tsx";
import useFetch, { CacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { INotificationsResponse } from "./type.ts";

export const useNotifications = () => {
  const fetch = useFetch();
  const { token } = useAuth();

  const { data, isLoading, isError, error } = useQuery<INotificationsResponse | null, Error, INotificationsResponse>({
    queryKey: ["notifications"],
    queryFn: () =>
      fetch<INotificationsResponse>(`${Urls.Notifications}`, {
        method: "GET",
      }, true, token),
    refetchInterval: 10000,
    gcTime: CacheTime,
    staleTime: CacheTime,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting notifications");
    }
  }, [error?.message, isError]);

  return {
    data,
    isFetching: isLoading,
  };
};
